import "./LikedList.scss";
import { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { produce } from "immer";
import EllipsePercentMatch from "../EllipsePercentMatch/EllipsePercentMatch";
import { formatPrice } from "../../utils/formatUtils";
import { updateComparisonChartStates } from "../../services/dealership-user";
import { groupInventory } from "../../utils/groupInventory";
import RestartButtonContainer from "../RestartButton/RestartButton";
import discountedGreenIcon from "../../assets/icons/discount-green.png";
import discountedRedIcon from "../../assets/icons/discount-red.png";
import { useDealershipContext } from "../../contexts/dealershipContext";
import LoadingScreen from "../LoadingScreen/LoadingScreen";
import ButtonGradient from "../ButtonGradient/ButtonGradient";
import { ReactComponent as MaeCoreLogoYellow } from "../../assets/logos/Mae-Minimized-Logo-Yellow.svg";
import NoMatches from "../NoMatches/NoMatches";
import ComparisonChartStatic from "../ComparisonChartStatic/ComparisonChartStatic";
import { ReactComponent as Star } from "../../assets/icons/star.svg";
import { AGED_INVENTORY } from "../../data/dealershipQuiz/agedInventory";
import UserProfile from "../UserProfile/UserProfile";
import { ReactComponent as CompareSelected } from "../../assets/icons/compare-selected.svg";
import { ReactComponent as ChevronUp } from "../../assets/icons/chevron-up.svg";
import { ReactComponent as ChevronDown } from "../../assets/icons/chevron-down.svg";
import { useDealershipUserContext } from "../../contexts/dealershipUserContext";
import { AIChatInterface } from "../AIChatInterface/AIChatInterface";
import UpdatePopup from "../UpdatePopup/UpdatePopup";
import cloneDeep from "lodash.clonedeep";
import { useRecordingSessionContext } from "../../contexts/recordingSessionContext";
const dealerDashboardURL = process.env.REACT_APP_DEALER_DASHBOARD_URL;
export function MatchSection({ vehicle }) {
  return (
    <div className="liked-card-match">
      {" "}
      <div className="liked-card-match__circle">
        <div className="liked-card-match-coloured-circle">
          <EllipsePercentMatch percentage={vehicle.compatibilityPercentage} />
        </div>
        <div className="liked-card-match-stamp">
          <p className="liked-card-match-stamp__number">
            {vehicle.compatibilityPercentage}
            <span className="liked-card-match-stamp__percent">%</span>
          </p>
          <p className="liked-card-match-stamp__text">match</p>
        </div>
      </div>
      <div className="match__text">
        <div className="match__text--row">
          <p className="text-bold">
            {vehicle.matchedUserRequirements}/{vehicle.totalUserRequirements}
          </p>
          <p className="text-normal">requirements</p>
        </div>
        <div className="match__text--row">
          <p className="text-bold">
            {" "}
            {vehicle.matchedFeatures.length}/{vehicle.totalFeatures.length}
          </p>
          <p className="text-normal">features</p>
        </div>
      </div>
    </div>
  );
}

function LikedList() {
  const navigate = useNavigate();
  const {
    dealershipName,
    dealershipId,
    linkMatchesToVDP,
    dealershipImgUrl,
    defaultInventoryImage,
    initContextFlag,
    testDrivePreApprovalFormEnabled,
    baseURL,
  } = useDealershipContext();
  const {
    user,
    userId,
    openedThroughEmail,
    quizIndexMapping,
    inventoryMatches,
    maeTrimsMatches,
    responseMessage,
    responseError,
    requestPending,
  } = useDealershipUserContext();

  const { recordingEnabled } = useRecordingSessionContext();

  const [userCarMatches, setUserCarMatches] = useState([]);
  const [groupedCarMatches, setGroupedCarMatches] = useState([]);
  const [carsToCompareList, setCarsToCompareList] = useState([]);
  const [zeroMatchesCase, setZeroMatchesCase] = useState(false);
  const [zeroMatchesPopup, setZeroMatchesPopup] = useState(false);
  const [showAllCars, setShowAllCars] = useState(false);
  const [numCarsToShow, setNumCarsToShow] = useState(3);
  const [showAIChatInterface, setShowAIChatInterface] = useState(false);
  const [searchExpandedPopup, setSearchExpandedPopup] = useState(false);

  const targetDivRef = useRef(null);
  const cardContainerRef = useRef(null);

  useEffect(() => {
    if (showAllCars) {
      setNumCarsToShow(userCarMatches.length);
    } else if (window.innerWidth < 600) {
      setNumCarsToShow(1);
    } else if (window.innerWidth < 850) {
      setNumCarsToShow(2);
    } else if (window.innerWidth < 1100) {
      setNumCarsToShow(3);
    } else if (window.innerWidth < 1250) {
      setNumCarsToShow(3);
    } else {
      setNumCarsToShow(3);
    }
  }, [showAllCars, window.innerWidth]);

  const lockScroll = () => {
    const scrollPosition = window.scrollY;
    window.scrollTo({ top: scrollPosition });
  };

  const getDisplayCarList = (groupedCarMatchesObj) => {
    let displayCarList = Object.keys(groupedCarMatchesObj).map(
      (maeIdKey, _) => {
        return groupedCarMatchesObj[maeIdKey].expand
          ? groupedCarMatchesObj[maeIdKey].carList
          : groupedCarMatchesObj[maeIdKey].faceCar;
      }
    );
    return displayCarList.flat(2);
  };

  useEffect(() => {
    const comparisonChartCarsInList = (
      currComparisonChartState,
      displayCarList
    ) => {
      const displayCarListIds = displayCarList.map((cars, _) => {
        return cars.maeId;
      });

      return currComparisonChartState.every((carId) => {
        return displayCarListIds.includes(carId);
      });
    };
    const toFillAndUpdateComparisonChartState = async (displayCarList) => {
      if (
        user.comparisonChartStates.at(-1) &&
        comparisonChartCarsInList(
          user.comparisonChartStates.at(-1),
          displayCarList
        )
      ) {
        const currComparisonChartStates = user.comparisonChartStates.at(-1);
        const currCarsToCompareList = displayCarList
          .map((cars, _) => {
            return currComparisonChartStates.includes(cars.maeId)
              ? cars.maeId
              : null;
          })
          .filter((item) => item !== null);
        setCarsToCompareList(currCarsToCompareList);
        return;
      }
      const currComparisonChartStates = displayCarList
        .slice(0, 3)
        .map((cars, _) => {
          return cars.maeId;
        });
      await updateComparisonChartStates(userId, currComparisonChartStates);

      const currCarsToCompareList = displayCarList
        .map((car, _) => {
          return car.maeId;
        })
        .filter((_, i) => {
          return i <= 2;
        });
      setCarsToCompareList(currCarsToCompareList);
    };

    if (userId && !requestPending) {
      if (inventoryMatches.length === 0) {
        setZeroMatchesCase(true);
        setZeroMatchesPopup(true);
      } else {
        //adding mae insights and keeping only awd matches for snow
        const inventoryMatchesWithTags = addMaeInsights(
          inventoryMatches,
          user,
          quizIndexMapping
        );
        // TODO: Entirely remove the logic for displaying Mae Car Matches
        //setMaeCarMatches(res.maeTrimsMatches);
        const groupedCarMatches = groupInventory(inventoryMatchesWithTags);
        setGroupedCarMatches(groupedCarMatches);
        let displayCarList = getDisplayCarList(groupedCarMatches);
        setUserCarMatches(displayCarList);
        setSearchExpandedPopup(
          user.searchExpandedFlag ? user.searchExpandedFlag : false
        );
        if (user && userId && userCarMatches.length === 0) {
          toFillAndUpdateComparisonChartState(displayCarList);
        }
      }
    }
  }, [userId, requestPending]);

  const addMaeInsights = (inventoryMatches, user, quizIndexMapping) => {
    //filter AWD cars
    const lifestyle =
      user.profile.quiz[quizIndexMapping.LIFESTYLE_INDEX].selectedOptions;

    if (
      lifestyle.includes("Snow") ||
      user.profile.quiz[quizIndexMapping.FEATURE_SELECT_INDEX]
        .selectedOptions[0]?.AWD
    ) {
      let inventoryMatchesAWD = inventoryMatches.filter(
        (car) =>
          car.driveTrain === "All Wheel Drive" ||
          car.driveTrain === "AWD" ||
          car.driveTrain === "4x4" ||
          car.driveTrain === "4WD"
      );

      if (inventoryMatchesAWD.length !== 0) {
        inventoryMatches = inventoryMatchesAWD;
      }
    }

    let sortedCarsByPrice = [...inventoryMatches];

    sortedCarsByPrice = sortedCarsByPrice.sort(
      (a, b) => a.raw_baseMSRP - b.raw_baseMSRP
    );

    const lowestAWDCarId = sortedCarsByPrice.find((car) =>
      [
        "AWD",
        "4WD",
        "All Wheel Drive",
        "4x4",
        "All-wheel drive",
        "Four-wheel drive",
      ].includes(car.driveTrain)
    )?.maeId;
    // const lowestFWDCarId = sortedCarsByPrice.find(car => car.driveTrain == "Front Wheel Drive")?.maeId;
    const lowestUsedAWDCarId = sortedCarsByPrice.find(
      (car) =>
        [
          "AWD",
          "4WD",
          "All Wheel Drive",
          "4x4",
          "All-wheel drive",
          "Four-wheel drive",
        ].includes(car.driveTrain) && car.raw_condition === "Used"
    )?.maeId;
    const lowestNewAWDCarId = sortedCarsByPrice.find(
      (car) =>
        [
          "AWD",
          "4WD",

          "All Wheel Drive",
          "4x4",
          "All-wheel drive",
          "Four-wheel drive",
        ].includes(car.driveTrain) && car.raw_condition === "New"
    )?.maeId;
    // const lowestUsedFWDCarId = sortedCarsByPrice.find(car => car.driveTrain == "Front Wheel Drive" && car.raw_condition == "Used")?.maeId;
    // const lowestNewFWDCarId = sortedCarsByPrice.find(car => car.driveTrain == "Front Wheel Drive" && car.raw_condition == "New")?.maeId;
    const lowestHybridCarId = sortedCarsByPrice.find(
      (car) => car.engine === "Hybrid"
    )?.maeId;
    const lowestUsedHybridCarId = sortedCarsByPrice.find(
      (car) => car.engine === "Hybrid" && car.raw_condition === "Used"
    )?.maeId;
    const lowestNewHybridCarId = sortedCarsByPrice.find(
      (car) => car.engine === "Hybrid" && car.raw_condition === "New"
    )?.maeId;
    const lowestPHEVCarId = sortedCarsByPrice.find(
      (car) => car.engine === "PHEV"
    )?.maeId;
    const lowestUsedPHEVCarId = sortedCarsByPrice.find(
      (car) => car.engine === "PHEV" && car.raw_condition === "Used"
    )?.maeId;
    const lowestNewPHEVCarId = sortedCarsByPrice.find(
      (car) => car.engine === "PHEV" && car.raw_condition === "New"
    )?.maeId;
    const lowestElectricCarId = sortedCarsByPrice.find(
      (car) => car.engine === "Electric"
    )?.maeId;
    const lowestUsedElectricCarId = sortedCarsByPrice.find(
      (car) => car.engine === "Electric" && car.raw_condition === "Used"
    )?.maeId;
    const lowestNewElectricCarId = sortedCarsByPrice.find(
      (car) => car.engine === "Electric" && car.raw_condition === "New"
    )?.maeId;
    const lowestLargeSUVCarId = sortedCarsByPrice.find(
      (car) => car.maeSegment === "Medium/Large SUV"
    )?.maeId;
    const lowestSmallSUVCarId = sortedCarsByPrice.find(
      (car) => car.maeSegment === "Small/Medium SUV"
    )?.maeId;

    inventoryMatches.forEach((car) => {
      car.maeInsights = [];

      car.driveTrainShort = car.driveTrain;
      if (
        car.driveTrain === "All Wheel Drive" ||
        car.driveTrain === "All-wheel drive"
      ) {
        car.driveTrainShort = "AWD";
      }
      if (
        car.driveTrain === "Rear Wheel Drive" ||
        car.driveTrain === "Rear-wheel drive"
      ) {
        car.driveTrainShort = "RWD";
      }
      if (
        car.driveTrain === "Front Wheel Drive" ||
        car.driveTrain === "Front-wheel drive"
      ) {
        car.driveTrainShort = "FWD";
      }
      if (car.driveTrain === "Four-wheel drive") {
        car.driveTrainShort = "4x4";
      }

      if (
        AGED_INVENTORY.dealershipId?.list.includes(
          car[AGED_INVENTORY[dealershipId].mappingKey]
        )
      ) {
        car.maeInsights.push("Manager's Special");
        car.agedInventory = true;
      }

      if (lowestUsedAWDCarId && lowestNewAWDCarId) {
        if (car.maeId === lowestUsedAWDCarId) {
          car.maeInsights.push(`Lowest-priced Used ${car.driveTrainShort}`);
        }
        if (car.maeId === lowestNewAWDCarId) {
          car.maeInsights.push(`Lowest-priced New ${car.driveTrainShort}`);
        }
      } else {
        if (car.maeId === lowestAWDCarId) {
          car.maeInsights.push(`Lowest-priced ${car.driveTrainShort}`);
        }
      }

      // if (lowestUsedFWDCarId && lowestNewFWDCarId) {
      //   if (car.maeId === lowestUsedFWDCarId) {
      //     car.maeInsights.push("Lowest$ Used FWD";
      //   }
      //   if (car.maeId === lowestNewFWDCarId) {
      //     car.maeInsights.push("Lowest$ New FWD";
      //   }
      // } else {
      //   if (car.maeId === lowestFWDCarId) {
      //     car.maeInsights.push("Lowest$ FWD";
      //   }
      // }

      if (lowestUsedElectricCarId && lowestNewElectricCarId) {
        if (car.maeId === lowestUsedElectricCarId) {
          car.maeInsights.push("Lowest-priced Used Electric");
        }
        if (car.maeId === lowestNewElectricCarId) {
          car.maeInsights.push("Lowest-priced New Electric");
        }
      } else {
        if (car.maeId === lowestElectricCarId) {
          car.maeInsights.push("Lowest-priced Electric");
        }
      }

      if (lowestUsedHybridCarId && lowestNewHybridCarId) {
        if (car.maeId === lowestUsedHybridCarId) {
          car.maeInsights.push("Lowest-priced Used Hybrid");
        }
        if (car.maeId === lowestNewHybridCarId) {
          car.maeInsights.push("Lowest-priced New Hybrid");
        }
      } else {
        if (car.maeId === lowestHybridCarId) {
          car.maeInsights.push("Lowest-priced Hybrid");
        }
      }

      if (lowestUsedPHEVCarId && lowestNewPHEVCarId) {
        if (car.maeId === lowestUsedPHEVCarId) {
          car.maeInsights.push("Lowest-priced Used PHEV");
        }
        if (car.maeId === lowestNewPHEVCarId) {
          car.maeInsights.push("Lowest-priced New PHEV");
        }
      } else if (car.maeId === lowestPHEVCarId) {
        car.maeInsights.push("Lowest-priced PHEV");
      }

      if (
        lowestLargeSUVCarId &&
        lowestSmallSUVCarId &&
        car.maeId === lowestLargeSUVCarId
      ) {
        car.maeInsights.push("Lowest-priced Large SUV");
      }

      if (user.selectedCarIds?.includes(car.maeId)) {
        car.maeInsights.push("Your Selected Car");
      }
    });

    return inventoryMatches;
  };

  const generateUserProfile = (event) => {
    if (event) {
      event.preventDefault();
    }
    const printContent = document.getElementById("print");
    const secondprintContent = document.getElementById("second-print");
    const noPrintHeader = document.getElementById("no-print-header");
    const noPrintHeaderTwo = document.getElementById("no-print-header-two");
    const noPrintList = document.getElementById("no-print-list");
    const noPrintListTwo = document.getElementById("no-print-list-two");
    const noPrintNoMatches = document.getElementById("no-print-nomatches");

    if (printContent) {
      printContent.style.display = "block";
    }

    if (secondprintContent) {
      secondprintContent.style.display = "none";
    }

    if (noPrintHeader) {
      noPrintHeader.style.display = "none";
    }

    if (noPrintHeaderTwo) {
      noPrintHeaderTwo.style.display = "none";
    }

    if (noPrintList) {
      noPrintList.style.display = "none";
    }

    if (noPrintListTwo) {
      noPrintListTwo.style.display = "none";
    }

    if (noPrintNoMatches) {
      noPrintNoMatches.style.display = "none";
    }
  };

  const navigateToProfilePage = () => {
    window.open(
      `${dealerDashboardURL}/customers/${userId}?dealershipId=${dealershipId}&auth=0&source=dealer-sales-copilot`,
      "_blank"
    );
  };

  useEffect(() => {
    const urlSearchString = window.location.search;
    const params = new URLSearchParams(urlSearchString);
    // setOpenedThroughEmail(params.get("email"));
    // setUserId(params.get("id"));

    if (params.get("openProfile") === "1") {
      const interval = setInterval(() => {
        const printContent = document.getElementById("print");
        if (printContent) {
          setSearchExpandedPopup(false);
          generateUserProfile(null);

          // Remove the 'openProfile' query parameter from the URL
          params.delete("openProfile");
          const newUrl = `${window.location.pathname}?${params.toString()}`;
          window.history.replaceState({}, document.title, newUrl);

          clearInterval(interval);
        }
      }, 100); // checks every 100ms

      // optional timeout fallback
      setTimeout(() => clearInterval(interval), 5000); // stop checking after 5 seconds
    }
  }, []);

  const openTestDriveInterface = () => {
    navigate(
      `${baseURL}testdrive?id=${userId}&email=${openedThroughEmail}&audio=${recordingEnabled}`
    );
  };

  const openUpdateProfileInterface = () => {
    navigate(
      `${baseURL}update-profile?id=${userId}&email=${openedThroughEmail}&audio=${recordingEnabled}`
    );
  };

  const generateChart = (event) => {
    event.preventDefault();
    const printContent = document.getElementById("print");
    const secondprintContent = document.getElementById("second-print");
    const noPrintHeader = document.getElementById("no-print-header");
    const noPrintHeaderTwo = document.getElementById("no-print-header-two");
    const noPrintList = document.getElementById("no-print-list");
    const noPrintListTwo = document.getElementById("no-print-list-two");
    const noPrintNoMatches = document.getElementById("no-print-nomatches");

    if (printContent) {
      printContent.style.display = "none";
    }

    if (secondprintContent) {
      secondprintContent.style.display = "block";
    }

    if (noPrintHeader) {
      noPrintHeader.style.display = "none";
    }

    if (noPrintHeaderTwo) {
      noPrintHeaderTwo.style.display = "none";
    }

    if (noPrintList) {
      noPrintList.style.display = "none";
    }

    if (noPrintListTwo) {
      noPrintListTwo.style.display = "none";
    }

    if (noPrintNoMatches) {
      noPrintNoMatches.style.display = "none";
    }
  };

  const backToMatches = (event) => {
    event.preventDefault();
    const printContent = document.getElementById("print");
    const secondprintContent = document.getElementById("second-print");
    const noPrintHeader = document.getElementById("no-print-header");
    const noPrintHeaderTwo = document.getElementById("no-print-header-two");
    const noPrintList = document.getElementById("no-print-list");
    const noPrintListTwo = document.getElementById("no-print-list-two");
    const noPrintNoMatches = document.getElementById("no-print-nomatches");

    if (printContent) {
      printContent.style.display = "none";
    }

    if (secondprintContent) {
      secondprintContent.style.display = "none";
    }

    if (noPrintHeader) {
      noPrintHeader.style.display = "block";
    }

    if (noPrintHeaderTwo) {
      noPrintHeaderTwo.style.display = "block";
    }

    if (noPrintList) {
      noPrintList.style.display = "block";
    }

    if (noPrintListTwo) {
      noPrintListTwo.style.display = "block";
    }

    if (noPrintNoMatches) {
      noPrintNoMatches.style.display = "block";
    }
  };

  const scrollToTargetDiv = () => {
    if (targetDivRef.current) {
      targetDivRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const toggleAIChatInterface = () => {
    setShowAIChatInterface(!showAIChatInterface);
  };

  const expandFunctionality = () => {
    setShowAllCars(!showAllCars);
    if (showAllCars) {
      scrollToTargetDiv();
    }
    if (!showAllCars) {
      lockScroll();
    }
  };

  const expandToAllTrims = (ev, maeIdKey) => {
    ev.stopPropagation();
    const tempGroupedCarMatches = cloneDeep(groupedCarMatches);
    let trimExpanded = !tempGroupedCarMatches[maeIdKey].expand;
    tempGroupedCarMatches[maeIdKey].expand = trimExpanded;
    const displayCarList = getDisplayCarList(tempGroupedCarMatches);
    setUserCarMatches(displayCarList);
    if (trimExpanded) {
      setShowAllCars(true);
      setNumCarsToShow(displayCarList.length);
    }
    setGroupedCarMatches(
      produce((groupedCarMatchesDraft) => {
        groupedCarMatchesDraft[maeIdKey].expand = trimExpanded;
      })
    );
  };

  const selectCarForCompare = async (_, maeId) => {
    const currCarsToCompareList = [...carsToCompareList];
    const carIndexPos = currCarsToCompareList.indexOf(maeId);

    if (carIndexPos === -1 && carsToCompareList.length > 3) {
      return;
    }
    if (carIndexPos === -1 && carsToCompareList.length === 3) {
      currCarsToCompareList.splice(0, 1);
      currCarsToCompareList.push(maeId);
    } else if (carIndexPos === -1) {
      currCarsToCompareList.push(maeId);
    } else {
      currCarsToCompareList.splice(carIndexPos, 1);
    }
    const comparisonChartStates = userCarMatches
      .map((cars, _) => {
        return currCarsToCompareList.includes(cars.maeId) ? cars.maeId : null;
      })
      .filter(Boolean);
    setCarsToCompareList(currCarsToCompareList);
    await updateComparisonChartStates(userId, comparisonChartStates);
  };

  if (requestPending || (!requestPending && responseError) || !userId) {
    return <LoadingScreen />;
  }
  const buttonText = dealershipId?.toLowerCase().startsWith("morrey")
    ? "Confirmation"
    : "Update Profile";
  return (
    <div className={`gallery fadeIn`} ref={targetDivRef}>
      {showAIChatInterface ? (
        <AIChatInterface close={toggleAIChatInterface} />
      ) : (
        <div
          style={{
            padding: "8px 24px",
            borderRadius: "9999px", // capsule shape
            background: "linear-gradient(to right, #facc15, #f97316)", // yellow to orange
            color: "white",
            fontWeight: "600",
            fontSize: "1rem",
            boxShadow: "0px 10px 15px rgba(255, 184, 67, 0.68)",
            cursor: "pointer",
            width: "100px",
            height: "40px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "fixed",
            bottom: "5em",
            right: "3em",
            zIndex: 99,
          }}
          onClick={toggleAIChatInterface}
        >
          Ask Mae!
        </div>
      )}
      {searchExpandedPopup && !zeroMatchesPopup && (
        <UpdatePopup
          Popupshow={setSearchExpandedPopup}
          main={
            "We had to widen our search to find similar vehicles that fit your criteria!"
          }
        />
      )}
      {zeroMatchesPopup && (
        <UpdatePopup
          Popupshow={setZeroMatchesPopup}
          main={
            "We didn't find any matches fitting your criteria, try updating the profile!"
          }
        />
      )}
      <div className="gallery__hero" id="no-print-header">
        <div className="gallery__hero--main">
          <img
            className="product_info__dealership_logo"
            src={dealershipImgUrl}
            alt=""
          />
          <RestartButtonContainer dealershipId={dealershipId} />
        </div>

        <div className="matches_page_heading">
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <h1 className="matches_page_heading--text">
              {user.firstName ? `${user.firstName}'s Matches` : "Your Matches"}
            </h1>
            <div
              className=".text"
              style={{
                fontWeight: "400",
                width: "auto",
                marginLeft: "0.5rem",
              }}
            >
              Powered By
            </div>
            <div className=".logo" style={{ marginLeft: "0.5rem" }}>
              <MaeCoreLogoYellow />
            </div>
          </div>
          {openedThroughEmail === "1" ? null : (
            <div className="profile-buttons">
              {testDrivePreApprovalFormEnabled ? (
                <ButtonGradient
                  text="Test Drive"
                  onClick={openTestDriveInterface}
                />
              ) : (
                ""
              )}

              <ButtonGradient
                text={buttonText}
                onClick={openUpdateProfileInterface}
              />

              <ButtonGradient
                text="Print Profile"
                onClick={navigateToProfilePage}
              />
              <ButtonGradient text="Print Chart" onClick={generateChart} />
            </div>
          )}
        </div>
      </div>

      <div
        ref={cardContainerRef}
        style={{ height: cardContainerRef, transition: "height 0.5s ease" }}
        className="liked-list"
        id="no-print-list"
      >
        <div className={`liked-list__wrapper`}>
          {userCarMatches.slice(0, numCarsToShow).map((vehicle, index) => {
            const maeIdKey = vehicle.maeId.split("~").slice(0, -1).join("~");
            return (
              <div
                key={index}
                className={`car-card`}
                onClick={(e) => selectCarForCompare(e, vehicle.maeId)}
              >
                <div
                  className={`liked-card`}
                  style={{
                    border: groupedCarMatches[maeIdKey]?.expand
                      ? `1px solid ${groupedCarMatches[maeIdKey]?.color}`
                      : `1px solid #fff`,
                  }}
                >
                  <div className="liked-card__thumbnail">
                    {
                      <div className="empty-selection">
                        {carsToCompareList.includes(vehicle.maeId) ? (
                          <CompareSelected />
                        ) : null}
                      </div>
                    }
                    <img
                      className="liked-card__thumbnail--img"
                      src={
                        defaultInventoryImage
                          ? defaultInventoryImage
                          : vehicle.raw_imageLink
                      }
                      alt={vehicle.make + vehicle.model}
                    />
                  </div>
                  <div className="liked-card__details">
                    <div style={{ display: "flex" }}>
                      <div
                        className={`liked-card__details--${vehicle.raw_condition}`}
                      >
                        {`${vehicle.raw_condition}`}
                      </div>
                      <div className={`liked-card__details--Other`}>
                        {`${vehicle.engine}`}
                      </div>
                      {vehicle.driveTrainShort &&
                        vehicle.driveTrainShort !== "MISSING_DRIVETRAIN" && (
                          <div className={`liked-card__details--Other`}>
                            {`${vehicle.driveTrainShort}`}
                          </div>
                        )}
                    </div>
                    {/* <div className={`liked-card__details--Other`}>
                    {`${vehicle.maeSegment}`}
                  </div> */}
                    <div className="liked-card__details--title">
                      {`${vehicle.year} ${vehicle.make} ${vehicle.model}`}
                    </div>
                    <div
                      style={{ fontSize: "0.9rem" }}
                    >{`${vehicle.trim}`}</div>
                    <div
                      style={{ fontSize: "0.9rem" }}
                    >{`#${vehicle.raw_stockNumber}`}</div>
                    {vehicle.raw_mileage ? (
                      <div style={{ fontSize: "0.9rem" }}>
                        {vehicle.raw_mileage} km
                      </div>
                    ) : (
                      ""
                    )}
                    <div className="liked-card__details--price">
                      <div style={{ display: "flex", alignItems: "center" }}>
                        ${formatPrice(vehicle.raw_baseMSRP)}
                        {vehicle.discountedFlag &&
                        !vehicle.agedInventory === true ? (
                          <img
                            className="liked-card__details--discount"
                            alt=""
                            src={discountedGreenIcon}
                          ></img>
                        ) : null}
                        {vehicle.agedInventory ? (
                          <img
                            className="liked-card__details--discount"
                            alt=""
                            src={discountedRedIcon}
                          />
                        ) : null}
                      </div>{" "}
                    </div>
                  </div>
                  <MatchSection vehicle={vehicle} />

                  {groupedCarMatches[maeIdKey]?.carList.length > 1 ? (
                    <div
                      className="liked-card__details--expandFunc"
                      onClick={(ev) => expandToAllTrims(ev, maeIdKey)}
                    >
                      {groupedCarMatches[maeIdKey]?.expand
                        ? "See Less <<"
                        : `See ${groupedCarMatches[maeIdKey].carList.length} Similar Vehicles >>`}
                    </div>
                  ) : null}

                  {vehicle.maeInsights.map((featureTag, index) => {
                    return featureTag === "Manager's Special" ||
                      featureTag === "Your Selected Car" ? (
                      <div className="liked-card__featured-orange" key={index}>
                        <Star
                          style={{ width: "20px", marginRight: "0.2rem" }}
                        />{" "}
                        {featureTag}
                      </div>
                    ) : (
                      <div className="liked-card__featured" key={index}>
                        <Star
                          style={{ width: "20px", marginRight: "0.2rem" }}
                        />{" "}
                        {featureTag}
                      </div>
                    );
                  })}

                  {/* 
                      Commenting out the Link to View Car Information on an External Website
                      <Link
                      className="liked-card__details--link"
                      to={linkMatchesToVDP ? vehicle.raw_internalLink : null}
                      key={index}
                      target={linkMatchesToVDP ? "_blank" : "_self"}
                      onClick={(e) => {
                        e.stopPropagation();
                        if (!linkMatchesToVDP) {
                          e.preventDefault();
                        }
                      }}
                    >
                      Click to View Vehicle
                    </Link> */}
                </div>
              </div>
            );
          })}
        </div>

        {zeroMatchesCase || userCarMatches.length < numCarsToShow ? null : (
          <div className="button-container" onClick={expandFunctionality}>
            <div className="line"></div>
            <button className="view-button">
              {showAllCars ? "View less matches" : "View more matches"}
              {showAllCars ? <ChevronUp /> : <ChevronDown />}
            </button>
            <div className="line"></div>
          </div>
        )}
      </div>

      <div className="liked-list" id="no-print-list-two">
        <ComparisonChartStatic
          targetDivRef={targetDivRef}
          carsToCompare={userCarMatches}
          name={user.firstName}
          quiz={user.profile.quiz}
          carsToComparesIds={carsToCompareList}
          matchesPage={true}
          quizIndexMapping={quizIndexMapping}
        />
      </div>

      {/* Hidden Print-Only UserProfile component */}
      <div id="print">
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            paddingBottom: "1rem",
          }}
        >
          <button
            style={{ background: "None", border: "None", fontSize: "1rem" }}
            onClick={backToMatches}
          >
            {" "}
            &#x25c0; Back
          </button>
          <button
            style={{ background: "None", border: "None", fontSize: "1rem" }}
            onClick={() => {
              window.print();
            }}
          >
            {" "}
            Print
          </button>
        </div>
        <UserProfile
          dealershipImgUrl={dealershipImgUrl}
          userCarMatches={userCarMatches}
        />
      </div>

      <div id="second-print">
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            paddingBottom: "1rem",
          }}
        >
          <button
            style={{ background: "None", border: "None", fontSize: "1rem" }}
            onClick={backToMatches}
          >
            {" "}
            &#x25c0; Back
          </button>
          <button
            style={{ background: "None", border: "None", fontSize: "1rem" }}
            onClick={() => {
              window.print();
            }}
          >
            {" "}
            Print
          </button>
        </div>
        <ComparisonChartStatic
          carsToCompare={userCarMatches}
          name={user.firstName}
          quiz={user.profile.quiz}
          carsToComparesIds={carsToCompareList}
          matchesPage={false}
        />
      </div>
    </div>
  );
}

export default LikedList;
